import { axiosGet, axiosPut } from '../plugins/axios.plugins';

const API_ENDPOINTS = {
  GET_ALL_CUSTOME_DB_BASEURL: `${process.env.VUE_APP_DATA_API}`,
};
const updateTableSchema = async (
  user,
  tableName,
  formData,
  updateFieldName
) => {
  const url = `${process.env.VUE_APP_DATA_API}/user-tables/${tableName}/table-schema/${updateFieldName}`;

  let myHeaders = new Headers();
  myHeaders.append(
    'Authorization',
    'Bearer ' + user.signInUserSession.accessToken.jwtToken
  );

  const res = await fetch(url, {
    body: formData,
    headers: myHeaders,
    method: 'PUT',
  });
  return res.json();
};

const getUserDatabases = () => {
  return axiosGet(`${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables`);
};

const getTableItems = (tableName) => {
  return axiosGet(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${tableName}/items`
  );
};

const getDataBaseLogs = (id) => {
  // Double encoding is needed because of the backend
  // the API will return an error on api-level (before even getting into api)
  // if its removed.
  return axiosGet(
    encodeURI(`${process.env.VUE_APP_DATA_API}/logs/${encodeURIComponent(id)}`)
  );
};

const getDataBaseAccessRights = (databaseID) => {
  return axiosGet(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${databaseID}/iam`
  );
};

const shareDataBaseTable = (databaseID, payload) => {
  return axiosPut(
    `${API_ENDPOINTS.GET_ALL_CUSTOME_DB_BASEURL}/user-tables/${databaseID}/share`,
    payload
  );
};

export {
  updateTableSchema,
  getUserDatabases,
  getDataBaseLogs,
  getTableItems,
  getDataBaseAccessRights,
  shareDataBaseTable,
};
